import { useState } from 'react';
import HeaderComp from './components/header/HeaderComp';
import Registry from './components/registry/Registry';
import SendTokens from './components/send/SendTokens';
import { NotificationsProvider } from './components/notifications/NotificationsProvider';
import { WalletProvider } from './components/wallet/WalletProvider';
import './App.css';

function App() {
  // Счётчик обновлений. Раньше здесь был `lastSend`, который никто не
  // принимал, а список обновлялся перезагрузкой страницы — вместе с потерей
  // подключённого кошелька. Реестр и балансы в шапке зависят от одного и того
  // же события: успешной отправки стейкинга.
  //
  // Смена ставки бессрочного крутит тот же счётчик: APR показан сразу в трёх
  // местах — в условиях формы, в окне условий и в каждой строке реестра
  // бессрочных, — и разъехаться они не должны.
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey((key) => key + 1);

  return (
    <NotificationsProvider>
      <WalletProvider>
        <div className="app_container">
          <HeaderComp refreshKey={refreshKey} />
          <SendTokens
            refreshKey={refreshKey}
            onStakeCreated={refresh}
            onRateChanged={refresh}
          />
          <Registry refreshKey={refreshKey} />
        </div>
      </WalletProvider>
    </NotificationsProvider>
  );
}

export default App;
